import React                          from 'react';
import { Button }                     from 'antd';
import ProviderDashboardContactsTable from './ProviderDashboardContactsTable';
import ContactForm                    from 'forms/ContactForm';
import ContactModel                   from 'models/ContactModel';
import { PagedCollection }            from 'collections/PagedCollection';
import FormattedMessageWrapper        from 'components/App/FormattedMessageWrapper';
import CardBox                        from 'components/App/CardBox';
import ProviderModel                  from 'models/ProviderModel';
import { AppForm }                    from 'components/App/AppForm';

interface ProviderDashboardContactsBoxProps {
  provider: ProviderModel;
}

class ProviderDashboardContactsBox extends React.Component<ProviderDashboardContactsBoxProps> {
  public contactCollection = new PagedCollection(ContactModel);

  public componentDidMount() {
    const { provider } = this.props;

    this.contactCollection
      .setFilter('provider', provider.id)
      .list();
  }

  public render() {
    const { provider } = this.props;

    return (
      <CardBox
        content={
          <ProviderDashboardContactsTable
            contactCollection={this.contactCollection}
          />
        }
        extra={
          <Button
            onClick={() => AppForm.open(ContactForm, {
              model: new ContactModel({ provider: provider?.iri }),
              onSuccess: () => this.contactCollection.list(),
            }, {
              title: <FormattedMessageWrapper id="Ajouter un contact" />,
            })}
          >
            <FormattedMessageWrapper id="Ajouter un contact" />
          </Button>
        }
        title={<FormattedMessageWrapper id="Contacts" />}
      />
    );
  }
}

export default ProviderDashboardContactsBox;
